<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
      title: "111"
    };
  },
  data() {
    return {};
  },
  created() {
    this.$Http.get("/slideShow/?slideShowModel=pc_title").then(res => {
      if (res.data.code == 200) {
        if (res.data.data.content.length > 0) {
          document.title = res.data.data.content[0].slideShowUrl;
        }


      } else {
        this.$message.error(res.data.desc);
      }
    });

    this.fnResize();
    window.addEventListener("resize", () => {
      this.fnResize();
    });
  },
  methods: {
    fnResize: function () {
      var deviceWidth =
        document.documentElement.clientWidth || window.innerWidth;
      if (deviceWidth >= 1920) {
        deviceWidth = 1920;
      }
      if (deviceWidth <= 1280) {
        deviceWidth = 1280;
      }
      document.documentElement.style.fontSize = deviceWidth / 19.2 + "px";
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  font-size: 14px;
}
#app,
html,
body {
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
*,
:after,
:before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
body .el-table th.gutter {
  display: table-cell !important;
}

.tableWrap {
  height: 100%;
  width: 100%;
  // background: #3c4451;
  padding: 0 0.2rem;
  // overflow-y: auto;
  .topSet {
    line-height: 35px;
    display: flex;
    padding: 0.1rem 0;
    color: #fff;
    .search {
      // flex: 0 0 80%;
      text-align: left;
      position: relative;
      .el-form-item__label {
        color: #000;
      }
      .m-b0 {
        margin-bottom: 0px !important;
      }
      .iconBtn {
        position: absolute;
        color: #ccc;
        display: table;
        width: 30px;
        right: 0;
        top: 0;
        cursor: pointer;
      }
    }
    .searchAll {
      flex: 0 0 100%;
      text-align: left;
      position: relative;
      .el-form-item__label {
        color: #000;
      }
      .m-b0 {
        margin-bottom: 0px !important;
      }
      .iconBtn {
        position: absolute;
        color: #ccc;
        display: table;
        width: 30px;
        right: 0;
        top: 0;
        cursor: pointer;
      }
    }
    .btn {
      // flex: 0 0 20%;
      text-align: right;
      .inline {
        display: inline-block;
      }
    }
  }
  .tableContent {
  }
}
.el-form-item__label {
  color: #606266;
  font-family: "Montserrat", sans-serif;
}
el-pagination {
  width: 100%;
  display: flex;
  justify-content: center;
}
//element message
.el-message {
  font-size: 0.2rem;
}
.el-dialog__header {
  border-bottom: 1.5px solid #08ad96;
}
.el-dialog__header {
  padding: 0 20px !important;
  height: 60px !important;
  display: flex;
  align-items: center;
  /* line-height: 20px !important; */
}
.el-menu-item-group__title {
  padding: 0 !important;
}
.overflowYAuto .el-table__body-wrapper {
  overflow-y: auto;
}

.topSet {
  position: relative;
  .el-upload-list {
    position: absolute;
    top: -25px;
    right: 10px;
    .el-upload-list__item:hover {
      background: #686a6c;
    }
    .el-upload-list__item-name {
      color: #fff;
      .el-upload-list__item-name [class^="el-icon"] {
        color: #fff !important;
      }
    }
    .el-upload-list__item .el-icon-close {
      color: #fff;
    }
  }
}
.el-card {
  margin: 10px;
  margin-right: 10px;
  // width: 100%;
}
</style>
<style>
.el-scrollbar__view div {
  font-size: 14px;
}
.el-tree-node__content:hover {
  background: #f5f7fa !important;
}
.el-radio,
.el-radio__input {
  float: left;
  line-height: 1 !important;
}
/* .el-radio__inner {
  margin-top: 0 !important;
} */
/* .el-radio,
.el-radio__input {
  float: left;
  line-height: 30px !important;
}
.el-checkbox__input {
  line-height: 30px;
}
.el-checkbox__label {
  width: 80%;
}
.el-radio__inner {
  margin-top: 14px;
}
.el-checkbox__inner {
  margin-top: 10px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue